import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import styles from './Footer.module.scss';

const FooterLayout = dynamic(() => import('./FooterLayout'), { ssr: false });
FooterLayout.displayName = 'FooterLayout';

const Footer = ({
  ratingValue,
  hideFooter,
  footerType
}) => {
  return (
    <div className={[
      hideFooter && styles['millesima-footer-hide']
    ].filter(Boolean).join(' ') || undefined}>
      <>
        <FooterLayout
          footerType={footerType}
          ratingValue={ratingValue}
        />
      </>
      <div className="d-none" itemProp="reviewRating" itemScope itemType="https://schema.org/Rating">
        <meta itemProp="worstRating" content="1" />
        <meta itemProp="bestRating" content="5" />
        <meta itemProp="ratingValue" content={ratingValue} />
      </div>
    </div>
  );
};

Footer.propTypes = {
  ratingValue: PropTypes.number,
  hideFooter: PropTypes.bool,
  footerType: PropTypes.string
};

export default Footer;
